import {
  ASYNC_FETCH,
  ASYNC_FETCH_REVIEW_SUCCESS,
  ASYNC_FETCH_FAILURE,
  ASYNC_FETCH_INVALIDATE,
  SET_REVIEW_DATA,
  SET_ISREVIEW_LOAD,
  SET_ISCHANGE_PLAN
} from '../constants';

import { updateObject } from '../../../shared/utilities/reducer';
import common from '../../../shared/utilities/common';

const initialState = {
  isFetching: true,
  statusCode: "",
  httpStatus: "",
  statusMessage: "",
  errorMessage: '',
  errorDesc: '',
  actionName: '',
  actionValue: '',
  errorObj: {},
  pageData: "",
  ReviewDataValue: {},
  isReviewLoad: false,
  isChangePlan: false
}



export const asyncFetch = (state, action) => {
  console.log("getSectionsBegin called")
  return updateObject(state, {
    isFetching: true
  });
};

export const asyncFetchSuccess = (state, action) => {
  let responseCode = action.msResp && action.msResp.responseInfo && action.msResp.responseInfo.responseCode;
  let responseMessage = action.msResp && action.msResp.responseInfo && action.msResp.responseInfo.responseMessage;
  let responseBody = action.msResp && action.msResp.body;

  return updateObject(state, {
    isFetching: false,
    statusCode: responseCode,
    statusMessage: responseMessage,
    errorMessage: common.isError(responseCode, responseMessage, responseBody),
    errorDesc: common.isErrorDesc(responseCode, responseMessage, responseBody),
    actionName: common.isActionName(responseCode, responseMessage, responseBody),
    actionValue: common.isActionValue(responseCode, responseMessage, responseBody),
    errorObj: responseCode !== "00" && action.msResp && action.msResp.responseInfo ? action.msResp.responseInfo.sectionErrors : null,
    pageData: responseBody
  });
};

export const asyncFetchFailed = (state, action) => {

  //Dont Delete this code untill implementing code to handel 500 status code error
  let msResp = action && action.err && action.err.response && action.err.response.data;
  let responseCode = msResp && msResp.responseInfo && msResp.responseInfo.responseCode;
  let responseMessage = msResp && msResp.responseInfo && msResp.responseInfo.responseMessage;
  let body = msResp && msResp.body;


  let httpStatus = action?.err?.response?.status;
  httpStatus = httpStatus ? httpStatus : action?.err?.request?.status;
  httpStatus = httpStatus ? httpStatus : action?.err?.response?.request?.status;

  return updateObject(state, {
    isFetching: false,
    pageData: {},
    statusCode: responseCode ? responseCode : '',
    httpStatus: httpStatus ? httpStatus : 200,
    errorMessage: common.isError(responseCode, responseMessage, body),
    errorDesc: common.isErrorDesc(responseCode, responseMessage, body),
    actionName: common.isActionName(responseCode, responseMessage, body),
    actionValue: common.isActionValue(responseCode, responseMessage, body),
    errorObj: responseCode !== "00" && msResp && msResp.responseInfo ? msResp.responseInfo.sectionErrors : action.err,
  });
};


export const setReviewDataValue = (state, action) => {
  return updateObject(state, {
    ReviewDataValue: action.data
  });
};

export const setisReviewLoadValue = (state, action) => {
  return updateObject(state, {
    isReviewLoad: action.data
  });
};

export const setisChangePlanValue = (state, action) => {
  return updateObject(state, {
    isChangePlan: action.data
  });
};

export const reviewPageReducer = (state = initialState, action) => {

  const { type } = action;
  switch (type) {
    case ASYNC_FETCH:
      return asyncFetch(state, action);
    case ASYNC_FETCH_REVIEW_SUCCESS:
      return asyncFetchSuccess(state, action);
    case ASYNC_FETCH_FAILURE:
      return asyncFetchFailed(state, action);
    // case ASYNC_FETCH_INVALIDATE:
    //   return Object.assign({}, state, { isFetching: false, pageData: {} });
    case SET_REVIEW_DATA:
      return setReviewDataValue(state, action);
    case SET_ISREVIEW_LOAD:
      return setisReviewLoadValue(state, action);
    case SET_ISCHANGE_PLAN:
      return setisChangePlanValue(state, action);
    default:
      return state;
  }
};

